<template>
  <div class="product-card-container">
    <div v-if="isBasicVariant" class="basic-variant card-body">
      <div class="basic-image">
        <img class="product-image" :src="productImagePath" alt="Imagem do produto" />
      </div>
    </div>
    <div v-else class="chip-variant" :class="isBackgroundCardVariant && 'use-background pa-2'">
      <div :style="{ backgroundColor: chipColor }" class="chip-label mb-1">{{ chipLabel }}</div>
      <div class="tag-image">
        <div v-if="useDefaultTag" class="default-tag">
          <mf-icon color="marca-1" fill>star</mf-icon>
        </div>
        <img v-else-if="hasTagImage" :src="tagImagePath" alt="Imagem da tag" />
        <div v-else class="no-usage"></div>
      </div>
      <div class="card-body use-chip">
        <div class="chip-image">
          <img class="product-image" :src="productImagePath" alt="Imagem do produto" />
        </div>
      </div>
      <div class="rule-chip-label">
        <span>{{ ruleChipLabel }}</span>
      </div>
      <div class="product-info d-flex flex-column">
        <h1 class="price mt-2">R$ {{ price | localeString(2) }}</h1>
        <div class="discount-section d-flex flex-row align-center">
          <div :class="!discountNumber ? 'fill-width' : 'px-2'" class="discount-label" :style="{ backgroundColor: discountColor }">{{ discountLabel }}</div>
          <span v-if="discountNumber" class="discount-number">{{ discountNumber | localeString(2) }}</span>
        </div>
        <div class="d-flex flex-column">
          <span class="product-name">{{ productName }}</span>
          <span class="product-measure">{{ productMeasure }}</span>
        </div>
        <span class="product-description">{{ productDescription }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { localeString } from '@/config/helpers.js'
import { highlightOffer } from '../../../mixins/highlight-offer'
export default {
  name: 'ProductCard',
  mixins: [highlightOffer],
  props: {
    variant: {
      type: String,
      required: true,
      default: 'basic',
      validator: (value) => ['basic', 'use-background-card', 'basic-chip'].includes(value),
    },
    chipColor: {
      type: String,
      default: '#0A3560',
    },
    discountColor: {
      type: String,
      default: '#A9DED5',
    },
    chipLabel: {
      type: String,
      default: '',
    },
    ruleChipLabel: {
      type: String,
      default: '',
    },
    price: {
      type: Number,
      default: 0,
    },
    discountLabel: {
      type: String,
      default: '',
    },
    discountNumber: {
      type: Number,
      default: 0,
    },
    productName: {
      type: String,
      default: '',
    },
    productMeasure: {
      type: String,
      default: '',
    },
    productDescription: {
      type: String,
      default: '',
    },
    useDefaultTag: {
      type: Boolean,
      default: false,
    },
    productImageSrc: {
      type: String,
      default: '@/assets/highlight-products-images/product-beats-1.png',
    },
  },
  data: () => ({}),
  computed: {
    isBasicVariant() {
      return this.variant === 'basic'
    },
    isBackgroundCardVariant() {
      return this.variant === 'use-background-card'
    },
    isBasicChipVariant() {
      return this.variant === 'basic-chip'
    },
    productImagePath() {
      return require(`@/assets/${this.productImageSrc}`)
    },
    tagImagePath() {
      return this.highlightTag.image
    },
    hasTagImage() {
      return this.tagImagePath.length > 0
    },
  },
  methods: {
    localeString,
  },
}
</script>
<style lang="scss" scoped>
.product-card-container {
  .card-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    background-color: white;
    border-radius: 8px;
  }
  .basic-variant {
    width: 72px;
    height: 72px;
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15);
  }
  .chip-variant {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    flex-shrink: 0;
    .chip-label {
      display: flex;
      width: 149px;
      padding: 4px 0 4px 0;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.16);
      color: white;
      font-family: Poppins;
      font-size: 10px;
      font-style: normal;
      font-weight: 500;
      line-height: 133%;
    }
  }
  .use-chip {
    display: flex;
    flex-direction: column;
    width: 149px;
    min-height: 120px;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.16);
  }
  .tag-image {
    position: relative;
    margin-bottom: -40px;
    margin-left: 8px;
    z-index: 1;
    width: 28px;
    height: 28px;
    div,
    img {
      border-radius: 50%;
      width: 100%;
      height: 100%;
    }
    .default-tag {
      display: flex;
      justify-content: center;
      align-items: center;
      border: solid 1px $marca-1;
    }
    .no-usage {
      background: linear-gradient(124deg, #ccd3d9 11.62%, #e6e8ea 51.08%, #ccd3d9 84.7%);
    }
    img {
      border-radius: 50%;
      width: 100%;
      height: 100%;
    }
  }
  .rule-chip-label {
    z-index: 1;
    margin-top: -35px;
    margin-left: 8px;
    width: 90%;
    padding: 2px 0 2px 0;
    border-radius: 31px;
    background: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #3d3d3d;
    font-family: Poppins;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 133%;
  }
  .product-info {
    gap: 8px;
    .price {
      color: #4f4f4f;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
    .discount-section {
      gap: 4px;
      .discount-label {
        padding-top: 2px;
        padding-bottom: 2px;
        display: flex;
        align-items: center;
        width: auto;
        border-radius: 31px;
        background: #b0e9df;
        text-align: center;
        color: #3d3d3d;
        font-family: Poppins;
        font-size: 8px;
        font-style: normal;
        font-weight: 500;
      }
      .discount-number {
        color: #a0aec0;
        font-family: Poppins;
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: 100%;
        text-decoration: line-through;
      }
    }
    .product-name {
      color: #000;
      font-family: Poppins;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 133%;
    }
    .product-measure {
      color: #a0aec0;
      font-family: Poppins;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 133%; /* 13.3px */
    }
    .product-description {
      color: #718096;
      font-family: Poppins;
      font-size: 8px;
      font-style: normal;
      font-weight: 400;
      line-height: 133%;
    }
  }
}
.product-image {
  width: 100%;
  height: 100%;
}
.basic-image {
  filter: blur(2px);
  width: 46px;
  height: 46px;
  flex-shrink: 0;
}
.chip-image {
  filter: blur(5px);
  width: 88px;
  height: 88px;
  flex-shrink: 0;
}
.use-background {
  border-radius: 15px;
  background: #fafafa;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
}
.fill-width {
  width: 100% !important;
  justify-content: center;
}
</style>
